<template>
  <div id="HomePage">
    <transition name="fade">
      <div v-if="loading" class="loader">
        <Loader/>
      </div>
    </transition>
    <!-- <md-toolbar class="md-primary"> -->
      <!-- <span class="md-title">My Title</span> -->
      <Header/>

      <Koszyk v-if="$i18n.locale === 'pl'"/>

      <!-- <div class="md-toolbar-section-end"> -->
        <md-button @click="showSidepanel = true">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-list" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style="color: white; font-size: 35px;">
          <path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
        </svg>
        </md-button>
      <!-- </div> -->
    <!-- </md-toolbar> -->
    <md-drawer class="md-right" :md-active.sync="showSidepanel">
      <md-list>
        <md-list-item>
          <button class="btn" @click="showSidepanel = false">{{$t('message.nowa')}}</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" @click="save_file">{{$t('message.zapisz')}}</button>
        </md-list-item>
        <md-list-item>
        <div class="upload-btn-wrapper">
          <button class="btn">{{$t('message.otworz')}}</button>
          <!-- <input type="file" name="myfile" /> -->
          <input type="file" name="myfile" @change="onFileChange" accept='application/json'>
        </div>
        </md-list-item>

        <!-- <md-list-item>
          <button class="btn">Drukuj</button>
        </md-list-item> -->
        <md-list-item>
          <button class="btn" @click="showDialogInfoProgram = !showDialogInfoProgram, showSidepanel = false">{{$t('message.o_programie')}}</button>
        </md-list-item>
        <!-- <md-list-item>
          <button class="btn" @click="showSidepanel = false">Instrukcja</button>
        </md-list-item> -->
      </md-list>
      <hr>
      <md-list>
        <!-- <md-list-item>
          <button class="btn" onclick="window.open('https://www.pulsar.pl/PL_848_dokumenty', '_blank');">Budowa szafy</button>
        </md-list-item> -->
        <!-- <md-list-item>
          <button class="btn" @click="showSidepanel = false">{{$t('message.budowa_szafy')}}</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" @click="showSidepanel = false">{{$t('message.tansport')}}</button>
        </md-list-item>
        <md-list-item>
          <button class="btn" @click="showDialogZapytanie = !showDialogZapytanie, showSidepanel = false">{{$t('message.wyslij_zapytanie')}}</button>
        </md-list-item> -->
      </md-list>
    </md-drawer>

    <md-content>
      <Content/>
    </md-content>

    <InfoProgram
      :showDialog="showDialogInfoProgram"
      @clickedClose="closedDialog"
    />
    <Zapytanie
      :showDialog="showDialogZapytanie"
      @clickedClose="closedDialog"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { app } from '../mixins/app'
// import { materials } from '../mixins/materials'
// import { calculation } from '../mixins/calculation'

import Loader from './Loader'
import Content from './Content'
import Header from './Header'
import InfoProgram from './Dialogs/InfoProgram'
import Zapytanie from './Dialogs/Zapytanie'
import Koszyk from './Koszyk'
// import DaneAdresowe from './Dialogs/DaneAdresowe'

export default {
  name: 'Temporary',
  // mixins: [app, materials, calculation],
  data: () => ({
    fileOpen: {},
    showSidepanel: false,
    showDialogInfoProgram: false,
    showDialogDaneAdresowe: false,
    showDialogZapytanie: false
  }),
  components: {
    Header, Content, Loader, InfoProgram, Zapytanie, Koszyk // , DaneAdresowe
  },
  computed: {
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['loading']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesorii'])
  },
  methods: {
    closedDialog (bool) {
      this.showDialogInfoProgram = bool
      this.showDialogDaneAdresowe = bool
      this.showDialogZapytanie = bool
    },
    save_file () {
      console.log('--- save_file ---')
      window.dataLayer.push({'event': 'save-click', 'label': 'Zapis konfiguracji do pliku', 'action': 'click', 'value': 1})
      // var shortOutputs = {}
      // shortOutputs.szafa = JSON.parse(JSON.stringify(this.outputs.szafa))
      // shortOutputs.items_przod = JSON.parse(JSON.stringify(this.outputs.items_przod))
      // shortOutputs.items_tyl = JSON.parse(JSON.stringify(this.outputs.items_tyl))
      // shortOutputs.items_inne = JSON.parse(JSON.stringify(this.outputs.items_inne))
      // shortOutputs.podzespoly = JSON.parse(JSON.stringify(this.outputs.podzespoly))

      // Object.keys(shortOutputs.szafa).forEach(key => {
      //   shortOutputs.szafa['cena'] = 0
      // })
      // Object.values(shortOutputs['items_przod']).forEach(item => {
      //   item.cena = 0
      // })
      // Object.values(shortOutputs['items_tyl']).forEach(item => {
      //   item.cena = 0
      // })
      // Object.values(shortOutputs['items_inne']).forEach(item => {
      //   item.cena = 0
      // })
      // Object.values(shortOutputs['podzespoly']).forEach(item => {
      //   if (item !== null) {
      //     if (Object.keys(item).length > 0) {
      //       Object.values(item).forEach(el => {
      //         el.cena = 0
      //       })
      //     }
      //   }
      // })

      var json = {
        'inputs': this.inputs,
        'outputs': this.outputs // shortOutputs
      }
      const data = JSON.stringify(json)
      var dzis = new Date().toLocaleDateString()
      var FileSaver = require('file-saver')
      var blob = new Blob([data], {type: 'application/json;charset=utf-8'})
      FileSaver.saveAs(blob, 'confi-rack-' + dzis + '.json')
      self.showSidepanel = false
    },
    onFileChange (e) {
      const file = e.target.files[0]
      const reader = new FileReader()
      var self = this
      reader.onload = (function (f) {
        return function (e) {
          // console.log(JSON.parse(e.target.result))
          self.fileOpen = JSON.parse(e.target.result)
          self.showSidepanel = false
          self.change_value_state(self.fileOpen)
        }
      })(file)
      reader.readAsText(file)
    },
    change_value_state (items) {
      var szafy = JSON.parse(JSON.stringify(this.ListaSzafy))
      var outputs = {}
      var akcesoria = JSON.parse(JSON.stringify(this.ListaAkcesorii))

      var szafa = szafy.filter(szafa => szafa.symbol === items.outputs.szafa.symbol)
      szafa[0].value = items.outputs.szafa.value
      szafa[0].label = items.outputs.szafa.label
      szafa = szafa[0]
      // ----------------
      var itemsPrzod = JSON.parse(JSON.stringify(items.outputs.items_przod))
      Object.values(itemsPrzod).forEach(item => {
        var findAkcesorium = akcesoria.filter(produkt => produkt.symbol === String(item.symbol))
        if (findAkcesorium[0]) {
          item.cena = findAkcesorium[0].cena
        }
      })
      // ----------------
      var itemsTyl = JSON.parse(JSON.stringify(items.outputs.items_tyl))
      Object.values(itemsTyl).forEach(item => {
        var findAkcesorium = akcesoria.filter(produkt => produkt.symbol === String(item.symbol))
        if (findAkcesorium[0]) {
          item.cena = findAkcesorium[0].cena
        }
      })
      // ----------------
      var itemsInne = JSON.parse(JSON.stringify(items.outputs.items_inne))
      Object.values(itemsInne).forEach(item => {
        var findAkcesorium = akcesoria.filter(produkt => produkt.symbol === String(item.symbol))
        if (findAkcesorium[0]) {
          item.cena = findAkcesorium[0].cena
        }
      })
      // ----------------
      var itemsPodzespoly = JSON.parse(JSON.stringify(items.outputs.podzespoly))
      Object.keys(itemsPodzespoly).forEach(key => {
        if (itemsPodzespoly[key] && Object.keys(itemsPodzespoly).length > 0) {
          Object.keys(itemsPodzespoly[key]).forEach(keyItem => {
            var findAkcesorium = akcesoria.filter(produkt => produkt.symbol === String(keyItem))
            if (findAkcesorium[0]) {
              itemsPodzespoly[key][keyItem].cena = findAkcesorium[0].cena
            }
          })
        }
        // if (item !== null && Object.keys(item).length > 0) {
        //   console.log(item)
        // }
        // var findAkcesorium = akcesoria.filter(produkt => produkt.symbol === String(item.symbol))
        // if (findAkcesorium[0]) {
        //   item.cena = findAkcesorium[0].cena
        // }
      })

      // console.log('--------------')
      outputs.szafa = szafa
      outputs.items_przod = itemsPrzod
      outputs.items_tyl = itemsTyl
      outputs.items_inne = itemsInne
      outputs.podzespoly = itemsPodzespoly
      outputs.item = {}
      outputs.cena = 0

      // console.log(outputs)

      this.$store.commit('app/SET_LOAD_FILE', true)
      this.$store.commit('app/LOAD_FILE', [items.inputs, outputs])

      // if (Object.keys(items.outputs).length > 0) {
      //   this.changeValueOutputs('rabat', 'value', items.rabat.value)
      // }
      // if (Object.keys(items.inputs).length > 0) {
      //   Object.keys(items.inputs).forEach(element => {
      //     if (items.inputs[element].value !== 0) {
      //       this.changeValueInputs(element, 'value', items.inputs[element].value)
      //     }
      //   })
      // }

      // this.obliczenia_sprzetu()
      // console.log(items.rabat)
    }
  }
}
</script>

<style scoped>
#HomePage {
  background: #efefef;
}
#HomePage .container{
  width:1048px !important;
  max-width:1048px !important;
}
button.md-button {
  position: absolute;
  top: 15px;
  right: 5px;
}
#HomePage .md-drawer {
  width: 215px;
  background: #404040 !important;
}
#HomePage .md-list {
  background: #404040 !important;
}
#HomePage .md-list li:hover{
  background: #292929 !important;
  margin: 0px 0px;
}
#HomePage .md-list li:hover button{
  color: #07b9ff;
}

.upload-btn-wrapper {
  position: relative;
  display: inline-block;
  border: 0px solid gray;
  border-radius: 0px;
}

.btn {
  color: gray;
  background: none;
  padding: 2px 4px;
  font-size: 15px;
  font-weight: bold;
  color:#fff;
  font-weight: normal;
}

.upload-btn-wrapper input[type=file] {
  font-size: 23px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue